/**
 * Recuperación ante despliegues: los chunks lazy llevan hash en el nombre, así que tras publicar
 * una versión nueva, una pestaña cargada con el index.html anterior pide chunks que ya no existen
 * en el servidor y el import dinámico revienta ("Failed to fetch dynamically imported module").
 * La única salida es recargar la página completa para obtener el index.html nuevo — eso hace el
 * navigation error handler de app.config.ts usando estos helpers.
 */

const RELOAD_AT_KEY = 'ftg.stale-chunk-reload-at';
/** Si la recarga no arregló el import (p. ej. el servidor está roto), no reintentar en bucle. */
const RELOAD_LOOP_WINDOW_MS = 30_000;

/** Mensajes de import dinámico fallido por navegador (Chromium / Safari / Firefox). */
const STALE_CHUNK_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /importing a module script failed/i,
  /error loading dynamically imported module/i,
];

export function isStaleChunkError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return STALE_CHUNK_PATTERNS.some((pattern) => pattern.test(error.message));
}

/**
 * Devuelve `true` (y deja marca) si procede recargar; `false` si ya se recargó hace menos de
 * 30 s — señal de que la recarga no resuelve el problema y recargar de nuevo solo crearía un bucle.
 */
export function shouldReloadForStaleChunk(storage: Storage, now: number): boolean {
  const lastReloadAt = Number(storage.getItem(RELOAD_AT_KEY));
  if (lastReloadAt > 0 && now - lastReloadAt < RELOAD_LOOP_WINDOW_MS) {
    return false;
  }
  storage.setItem(RELOAD_AT_KEY, String(now));
  return true;
}
